<template>
  <v-container>
    <div v-if="404" class="errors">
      <h2 class="error-text" align ='center'>{{resourceItem == null ? $t('notFound.pageNotFound') : resourceItem}}</h2>
      <v-img slot-scope="" width="50%" :src="notFound" />
      <h2 class="error-text"   align ='center'>{{$t('notFound.oops')}}</h2>
      <p>{{$t('notFound.pageUnavailable')}}</p>
      <v-btn width="15rem" style="color: white" color="#0033AA" to="/">
        {{$t('notFound.goBack')}}
      </v-btn>
    </div>
    <div v-else class="errors">
      <v-img width="30%" :src="serverError" />
      <h2 class="error-text">{{$t('notFound.serverError')}}</h2>
      <v-btn width="15rem" style="color: white" color="#0033AA" to="/">
        {{$t('notFound.goBack')}}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import notFound from "@/assets/notfound.png"
import serverError from "@/assets/undraw_warning_cyit.svg"

export default {
  name: 'NotFound',
  props: {
    resourceItem: {
      type: String,
    },
  },
  data: () => ({
    notFound,
    serverError,
  }),
}
</script>

<style scoped>
.errors {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4rem;
}

.error-text {
  margin-bottom: 1.5rem;
}

.link{
  color: blue;
  text-decoration:none;
  font-size: 1.2rem;
}
</style>
